angular.module('igs.grid', []).directive('igsGrid', ['$window', 
    function($window) {
        return{
            restrict: 'E',
            template: require('./IgsGrid.html'),
            scope: {
                data: '=',
                header: '=',
                sortBy: '@?',
                sortDescending: '@?',
                filterData: '=?',
                limitResults: '=?',
                displaySummary: '=?',
                tableClass: '=?'
            },
            link: function($scope) {
                function init() {
                    if (!$scope.limitResults) {
                        $scope.limitResults = 99999;
                    }
                }

                $scope.tableClass = $scope.tableClass || 'table table-striped table-bordered table-condensed small table-responsive';

                $scope.filterData = $scope.filterData || {};

                $scope.getActionText = function(headerData, value) {
                    return typeof headerData.action.property !== 'undefined'
                        ? value[headerData.action.property]
                        : headerData.action.name;
                };

                $scope.toType = function (obj) {
                    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
                };
                $scope.sortClick = function(headerData) {
                    if (headerData.property === $scope.sortBy) {
                        $scope.sortDescending = !$scope.sortDescending;
                    } else {
                        $scope.sortBy = headerData.property;
                        $scope.sortDescending = false;
                    }
                };
                $scope.sort = function() {
                    return $scope.sortBy ? $scope.sortBy : '';
                };
                $scope.getPropertyValue = function(headerData, value) {
                  return headerData.propertyConverter 
                    ? headerData.propertyConverter(value[headerData.property])
                    : value[headerData.property]
                }

                init();
            }
        }
    }
]);


/*  Acceptable headers object
headers: [
                        {
                            name: 'View User',
                            css: 'col-xs-1',
                            blockSort: true,
                            blockFilter: true,
                            visible: function(value){
                                return true;
                            },
                            action: {
                                name: 'View', click: function (value) {
                                    manageUsersService.getUser(value.UserId).then(function(data) {
                                        $scope.user = data;
                                        $scope.screen.currentUserId = value.UserId;
                                        setupUserRoles();
                                    });
                                },
                                css: 'btn-primary'
                            } 
                        },
                        { name: 'Username', property: 'Username' },
                        { name: 'Email Address', property: 'EmailAddress' },
                        { name: 'Call Copy User Name', property: 'CallCopyUserName' },
                        { name: 'Association Name', property: 'AssociationName' }
                    ]
*/